import { z } from 'zod'
import { oc } from '@orpc/contract'

export const deleteOrganizationConnect = oc
  .route({ method: 'DELETE', path: '/v2/organizations/connects/{id}' })
  .input(z.object({ id: z.string() }))
  .output(z.object({}))
